// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Added v7 — see `ChannelModifier.schema_version`.
 *
 * A tri-state boolean for channel-modifier fields that need "unset" as well as
 * true and false. `UNSET` MUST stay 0: pre-v7 rows read every v7 field as its
 * `FlatBuffer` default, and 0 is also the Go Object-API zero value and the
 * Postgres column default, so 0 has to mean "behave as before v7" — which a
 * `bool` defaulting to false could not express.
 *
 * Added v9: `MIRROR` and `INVERT` say where a modifier's payload `active`
 * comes from instead of fixing it. They are valid ONLY on
 * `ChannelModifier.payload_active`; every other use of this enum (an
 * expected step's `expected_active`, a `SEND` step's `payload_active`, a
 * precondition's `expected_active`) stays a fixed level and rejects them.
 *   `UNSET` (0)    — `active: true`, the pre-v7 behavior.
 *   `ACTIVE` (1)   — always `active: true`.
 *   `INACTIVE` (2) — always `active: false`.
 *   `MIRROR` (3)   — the payload's `active` equals the source message's.
 *   `INVERT` (4)   — the payload's `active` is the opposite of the source
 *                    message's.
 * Values are APPEND-ONLY.
 */
export enum ActiveState {
  UNSET = 0,
  ACTIVE = 1,
  INACTIVE = 2,
  MIRROR = 3,
  INVERT = 4,
}
